import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store, persistor } from './store';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import LoginPage from './pages/LoginPage';
import LoginAutoPage from './pages/LoginAutoPage';
import Dispatch from './pages/Dispatch';
import MRMSMapPage from './pages/MRMSMapPage';
import CallTaker from './pages/CallTaker.js';
import RouteChart from './pages/RouteChartView';
import { resetConfiguration } from './features/common/configurationSlice'; 
import APICom from './utils/helpers/APICom';
import { SetCombineData } from './features/common/combinedataSlice';
import PersistStorage from './utils/helpers/PersistStorage';
import DemoMTSchedulerLayout from './layouts/DemoMTSchedulerLayout.js';
import MicroTransitMySimulation from './pages/MicroTransitMySimulation';


export default function Index() {
    const { ConfigurationsLoaded, CurrentApplicationVersion } = useSelector((store) => store.configuration);
    const { loginData } = useSelector((store) => store.login);
    const [childAffiliate, setChildAffiliate] = useState(0);
    const dispatch = useDispatch();

    const handleAffChange = (data)=>{
        try{
            setChildAffiliate(data);
            PersistStorage.save("affSelectedCallAgent", data, 999, true);
            // console.log("Dispatch Data", data);
        }
        catch(err){console.log(err);}
    };

    const handleRowSelection = (data)=>{
        try{
            // console.log(data);
            if(data && data.length > 0)
            {
                PersistStorage.save("rowDataCallAgent", data, 999, true);
            }
            else
            {
                PersistStorage.save("rowDataCallAgent", [], 999, true);
            }
        }
        catch(err){console.log(err);}
    };
    
    useEffect(() => {
        dispatch(resetConfiguration());
        // let _CurrentAppVersion = process.env.version;
        // if (ConfigurationsLoaded === false || CurrentApplicationVersion !== _CurrentAppVersion) {
        //     dispatch(resetConfiguration());
        // }
        const PopulateCombineData = async(e) => {
            try {
                let vUserAssignedAffiliates = "-1";
                // if(!loginData.IsPowerUser) {
                //     vUserAssignedAffiliates = loginData.UserAffiliateList;
                // }
                var response = await APICom.fetchData("AspDotNetCoreURL", "CombinedData/GetCombinedDataByAffiliateIDs?vAffiliateIds=" + vUserAssignedAffiliates, "get", {}, {});
                response = JSON.parse(response.data);
                dispatch(SetCombineData({data: response["FamilyData"], name:"FamilyData"}));
                dispatch(SetCombineData({data: response["AffiliateData"], name:"AffiliateData"}));
                dispatch(SetCombineData({data: response["BrokerServingAffiliatesData"], name:"BrokerServingAffiliatesData"}));
                dispatch(SetCombineData({data: response["FundingSourceData"], name:"FundingSourceData"}));
                dispatch(SetCombineData({data: response["ASCSSettingData"], name:"ASCSSettingData"}));
                dispatch(SetCombineData({data: response["CancelReasonData"], name:"CancelReasonData"}));
                dispatch(SetCombineData({data: response["NoShowReasonData"], name:"NoShowReasonData"}));
                dispatch(SetCombineData({data: response["DispatchDriverData"], name:"DispatchDriverData"}));
                dispatch(SetCombineData({data: response["DispatchVehicleData"], name:"DispatchVehicleData"}));
                dispatch(SetCombineData({data: response["BrokerCancelReasonData"], name:"BrokerCancelReasonData"}));
                dispatch(SetCombineData({data: response["VehicleInfoData"], name:"VehicleInfoData"}));
                dispatch(SetCombineData({data: response["AttributeData"].Table, name:"AttributeData"}));
                dispatch(SetCombineData({data: response["GlobalASCSData"], name:"GlobalASCSData"}));
                dispatch(SetCombineData({data: response["ZoneVerticesData"], name:"ZoneVerticesData"}));
                dispatch(SetCombineData({data: response["VirtualStopsData"], name:"VirtualStopsData"}));
                dispatch(SetCombineData({data: response["ClassOfServiceData"], name:"ClassOfServiceData"}));
                dispatch(SetCombineData({data: response["PaymentTypesData"], name:"PaymentTypesData"}));
                dispatch(SetCombineData({data: response["RCZZoneVerticesData"], name:"RCZZoneVerticesData"}));
                
                try{
                    let iATSPID = loginData ? loginData.iUserAffiliateID.toString() : "-1" ;
                    let data = {
                        "iATSPID": iATSPID
                    }
                    let responseT = await APICom.fetchData("", "TripActions/GetServiceRequestColorCodes", "post", { "Content-Type": "application/json" }, data, null);
                    let api_data = responseT.data.data ? responseT.data.data : []
                    // Elvis operator in ECMAScript 2020
                    if (api_data?.length) {
                        // array and array.length are truthy
                        if (api_data.length === 3)
                        {
                            //setting value for row and column cell seperate
                            // index 0 list is row data & index 1 is col. data
                            dispatch(SetCombineData({data: api_data, name:"DispatchGridColorsData"}));

                        }

                    }
                }
                catch(e) {
                    
                }
            }
            catch(e){console.log(e);}
        };
        PopulateCombineData();
    }, [dispatch]);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<MainLayout affSelected={childAffiliate}/>}>
                    <Route path="Login" element={<LoginPage />} />
                    <Route path="LoginAuto" element={<LoginAutoPage />} />
                    <Route path="Home" element={<Home />} />
                    <Route path="Dispatch" element={<Dispatch sendAffToParent={handleAffChange} gridRowData={handleRowSelection}/>} />
                    <Route path="MapPage" element={<MRMSMapPage />} />
                    <Route path="CallAgent" element={<CallTaker />} />
                    <Route path="routeschart" element={<RouteChart />} />
                    <Route path="*" element={<NoPage />} />
                </Route>
                <Route path="/simulationscheduler" element={<DemoMTSchedulerLayout />}/>
                <Route path="/mysimulation" element={<MicroTransitMySimulation />}/>
            </Routes>
        </BrowserRouter>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Index />
        </PersistGate>
    </Provider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
